import { diaryByIdQueryOptions } from "@/features/diaries/api";
import { extractObservationById } from "@/features/observations/hooks/useExtractObservation";
import ObservationFormPage from "@/features/pages/components/ObservationFormPage";
import type { FormViewT } from "@/types/database/forms";
import { createFileRoute } from "@tanstack/react-router";
import { useNav } from "../../../../../../../../../../utils/nav";

const Page = () => {
	const { patientId, observation } = Route.useLoaderData();
	const { pageIndex, diaryId, observationId, entryId } = Route.useParams();

	useNav([
		{ label: "Patients", route: { to: "/patients" } },
		{
			route: { to: "/patients/$diaryId", params: { diaryId } },
			label: "Diary",
		},
		{
			route: {
				to: "/diaries/$diaryId/observation/$observationId/entry/$entryId/page/$pageIndex",
				params: { diaryId, observationId, entryId, pageIndex },
			},
			label: "Observation",
		},
	]);

	return (
		<>
			<ObservationFormPage
				patientId={patientId}
				pageIndex={Number(pageIndex)}
				form={observation?.form as FormViewT}
				route={Route}
				nextEntry={observation?.next_entry}
			/>
		</>
	);
};

export const Route = createFileRoute(
	"/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/page/$pageIndex/",
)({
	component: Page,
	loader: async ({ context, params }) => {
		const diary = await context?.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		);
		const observation = extractObservationById(diary, params.observationId);

		return {
			patientId: diary?.patient_id ?? "",
			observation: observation,
		};
	},
});
